import React from 'react';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { PackingOrderDataForm, PackingOrderFilters } from '../../../../app/models/PackingOrder';

interface Props {
  packingOrders: PackingOrderDataForm[];
  totalRows: number;
  loading?: boolean;
  edit?: (id: number) => void;
  destroy?: (id: number) => void;
  filter: PackingOrderFilters;
  setFilter: (filter: PackingOrderFilters) => void;
  callbackSuccess: () => void;
}

const PackingOrderDataTable = ({
  packingOrders,
  totalRows,
  loading = false,
  edit,
  destroy,
  filter,
  setFilter
}: Props) => {
  const columns = [
    {
      name: 'ID',
      selector: (row: any) => row.id,
      sortable: true,
      sortField: 'id',
      width: '80px',
      cell: (row: PackingOrderDataForm) => <span>{row.id}</span>
    },
    {
      name: 'Sociedad',
      selector: (row: any) => row.society_name,
      sortable: true,
      sortField: 'society__id',
      cell: (row: PackingOrderDataForm) => <span>{row.society_name ?? '-'}</span>
    },
    {
      name: 'Fecha programa',
      selector: (row: any) => row.program_date,
      sortable: true,
      sortField: 'program_date',
      cell: (row: PackingOrderDataForm) => <span>{row.program_date ?? '—'}</span>
    },
    {
      name: 'Fecha inicio',
      selector: (row: any) => row.start_date,
      sortable: true,
      sortField: 'start_date',
      cell: (row: PackingOrderDataForm) => <span>{row.start_date ?? '-'}</span>
    },
    {
      name: 'Fecha fin',
      selector: (row: any) => row.end_date,
      sortable: true,
      sortField: 'end_date',
      cell: (row: PackingOrderDataForm) => <span>{row.end_date ?? '-'}</span>
    },
    {
      name: 'Estado',
      selector: (row: any) => row.status_label ?? row.status,
      sortable: true,
      sortField: 'status',
      cell: (row: PackingOrderDataForm) => <span>{row.status_label ?? row.status ?? '-'}</span>
    },
    {
      name: 'Acciones',
      selector: (row: any) => row.id,
      sortable: false,
      width: '150px',
      cell: (row: PackingOrderDataForm) => (
        <div>
          {edit && (
            <ButtonTableAction
              callbackFunction={() => edit(row?.id ?? -1)}
              classIcon="mdi mdi-pencil"
              colorIcon="text-warning"
              errorMessage="No se puede editar este registro."
              title="Editar"
            />
          )}
          {destroy && (
            <ButtonTableAction
              callbackFunction={() => destroy(row?.id ?? -1)}
              classIcon="mdi mdi-delete"
              colorIcon="text-danger"
              errorMessage="No se puede eliminar este registro."
              title="Eliminar"
            />
          )}
        </div>
      )
    }
  ];

  return (
    <div className="row mt-3">
      <div className="col">
        <DefaultDataTable
          columns={columns}
          data={packingOrders}
          progressPending={loading}
          paginationTotalRows={totalRows}
          filter={filter}
          setFilter={setFilter}
        />
      </div>
    </div>
  );
};

export default PackingOrderDataTable;
